<component
  v-if="shouldRenderConfig"
  v-bind:is="getContainerType"
  v-bind:class="getClassName"
>
  <appSelectOption
    v-for="(option,key) in getOtherOptions"
    v-bind:key="key"
    v-bind:propsData="option"
    v-bind:selectId="'others_select' + key"
    v-bind:optionType="optionsType"
  ></appSelectOption>
</component>
